import React, { useState } from "react";
import Achievement from "../assets/Images/Achievement.jpg";
import holi1 from "../assets/Images/DSC_2366.JPG";
import holi2 from "../assets/Images/Navaratri1.jpeg";
import diwali1 from "../assets/Images/DSC_4218.JPG";
import diwali2 from "../assets/Images/DSC_2862.JPG";
import celebration from "../assets/Images/Gemini_Generated_Image_csgnpkcsgnpkcsgn (1).png";
import expo1 from "../assets/Images/sirmam1.png";
import expo2 from "../assets/Images/visko 31 cake.png";
import GaneshChaturthi1 from "../assets/Images/DSC_2382.JPG";
import GaneshChaturthi4 from "../assets/Images/Navaratri4.jpeg";
import GaneshChaturthi5 from "../assets/Images/Navaratri5.jpeg";
import GaneshChaturthi7 from "../assets/Images/Navaratri7.jpeg";
import GaneshChaturthi8 from "../assets/Images/Navaratri8.jpeg";
import IndependenceDay from "../assets/Images/IndependenceDay.jpg";
import IndependenceDay2 from "../assets/Images/IndependenceDay2.jpg";
import pc1 from "../assets/Images/pc1.png";
import pc2 from "../assets/Images/pc2.JPG";
// import pc3 from "../assets/Images/pc3.JPG";
import pc4 from "../assets/Images/pc4.JPG";
import pc5 from "../assets/Images/pc5.JPG";
import pc6 from "../assets/Images/pc6.JPG";
import pc7 from "../assets/Images/pc7.JPG";
import pc8 from "../assets/Images/pc8.JPG";
import pc9 from "../assets/Images/pc9.JPG";
import pc10 from "../assets/Images/pc10.JPG";
import pc11 from "../assets/Images/pc11.jpg";
// import pc12 from "../assets/Images/pc12.jpg";
import pc13 from "../assets/Images/pc13.jpg";
import hk from "../assets/Images/hk.png";






const imageData = [
  { id: 1, category: "event2", src: holi1 },
  { id: 2, category: "event2", src: holi2 },
  { id: 3, category: "event3", src: diwali1 },
  { id: 4, category: "event3", src: diwali2 },
  { id: 5, category: "event4", src: expo1 },
  { id: 6, category: "event4", src: expo2 },
  { id: 7, category: "event1", src: celebration },
  { id: 8, category: "event1", src: Achievement },
  { id: 9, category: "event5", src: GaneshChaturthi1 },
  { id: 12, category: "event5", src: GaneshChaturthi4 },
  { id: 13, category: "event5", src: GaneshChaturthi5 },
  { id: 15, category: "event5", src: GaneshChaturthi7 },
  { id: 16, category: "event5", src: GaneshChaturthi8 },
  { id: 17, category: "event6", src: IndependenceDay },
  { id: 18, category: "event6", src: IndependenceDay2 },
  { id: 19, category: "event7", src: pc1 },
  { id: 20, category: "event7", src: pc2 },
  // { id: 21, category: "event7", src: pc3 },
  { id: 22, category: "event7", src: pc4 },
  { id: 23, category: "event7", src: pc5 },
  { id: 24, category: "event7", src: pc6 },
  { id: 25, category: "event7", src: pc7 },
  { id: 26, category: "event7", src: pc8 },
  { id: 27, category: "event7", src: pc9 },
  { id: 28, category: "event7", src: pc10 },
  { id: 29, category: "event7", src: pc11 },
  // { id: 30, category: "event7", src: pc12 },
  { id: 31, category: "event7", src: pc13 },
  { id: 32, category: "event7", src: hk },

];


const Activity = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [visibleCount, setVisibleCount] = useState(6);

  const filteredImages =
    selectedCategory === "all"
      ? imageData
      : imageData.filter((img) => img.category === selectedCategory);

  const displayedImages = filteredImages.slice(0, visibleCount);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setVisibleCount(6);
  };

  const handleViewMore = () => {
    setVisibleCount(filteredImages.length);
  };

  const handleViewLess = () => {
    setVisibleCount(6);
  };

  return (
    <div id="Activity">
      <div>
        <div className="container text-center py-5">
          <div className="container section-title" data-aos="fade-up">
            <h2>Our Gallery</h2>
            <p>Building Stronger Bonds Together</p>
          </div>

          {/* <div className="mb-4 mt-4 d-flex justify-content-center  flex-wrap gap-2">
            {[
              { key: "all", label: "All Images" },
              { key: "event1", label: "100k Achieved" },
              { key: "event2", label: "Holi " },
              { key: "event3", label: "Diwali " },
              { key: "event4", label: "Expo Event" },
              { key: "event5", label: "Ganesh Chaturthi" },
              { key: "event6", label: "Independence Day" },
            ].map(({ key, label }) => (
              <button
                key={key}
                className={`btn category-btn ${selectedCategory === key ? "btn-custom-orange" : "btn-infoo"
                  }`}
                onClick={() => handleCategoryClick(key)}
              >
                {label}
              </button>
            ))}
          </div> */}

          <div className="row g-3">
            {displayedImages.map((img) => (
              <div className="col-md-5 col-lg-4 mx-auto mx-lg-0" key={img.id}>
                <div
                  className="d-flex justify-content-center align-items-center bg-light"
                  style={{
                    height: "250px",
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={img.src}
                    alt={`Event ${img.id}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-4">
            {visibleCount < filteredImages.length ? (
              <button className="btn btn-dangerr px-4" onClick={handleViewMore}>
                View More
              </button>
            ) : filteredImages.length > 6 ? (
              <button
                className="btn btn-secondaryy px-4"
                onClick={handleViewLess}
              >
                View Less
              </button>
            ) : null}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Activity;
